import { createRoot } from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import App from "./App.tsx";
import "./index.css";
import { applyConsent, getStoredConsent } from "@/lib/consent";
import posthog from "posthog-js";

// GDPR / §25 TTDSG: nothing non-essential runs before consent. PostHog and
// Sentry (error tracking) start only for the categories recorded via the
// cookie consent modal; without a stored record everything stays off.
const consent = getStoredConsent();

// Only initialise PostHog when a key is actually configured. Calling
// posthog.init(undefined, …) emits the "PostHog was initialized without a token"
// warning on every page load, which is noisy in dev/preview builds where the
// VITE_POSTHOG_KEY env var is intentionally blank.
const posthogKey = import.meta.env.VITE_POSTHOG_KEY;
if (typeof posthogKey === "string" && posthogKey.trim().length > 0) {
  posthog.init(posthogKey, {
    api_host: import.meta.env.VITE_POSTHOG_HOST,
    person_profiles: "identified_only",
    // Consent-gated: no cookies/localStorage and no capturing until the
    // visitor opts in (applyConsent() below flips both when granted).
    persistence: consent?.analytics ? "localStorage+cookie" : "memory",
    opt_out_capturing_by_default: true,
  });
}

applyConsent(consent);

createRoot(document.getElementById("root")!).render(
  <HelmetProvider>
    <App />
  </HelmetProvider>
);
